<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
              <a href="javascript: void(0);" class="btn btn-success btn-sm mt-3">
                <i class="mdi mdi-plus mr-1"></i> Add New
              </a>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;&nbsp;
                    <b-form-select v-model="perPage" size="sm" :options="pageOptions" class="mx-1"></b-form-select>&nbsp;&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-right">
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ml-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                :items="tableData"
                :fields="fields"
                bordered striped
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
              >
                <template #cell(name)="row">  
                    <img
                    src="@/assets/images/users/avatar-1.jpg"
                    class="mr-3 rounded-circle avatar-xs"
                    alt="user-pic"
                    />
                        {{row.item.name}}
                </template>
                <template #cell(classification)="row">  
                   <span class="badge badge-primary p-1 px-1" variant="danger" v-if="row.item.classification == 'terorisme'"> {{row.item.classification}}</span>
                   <span class="badge badge-info p-1 px-1" v-else-if="row.item.classification == 'judi'"> {{row.item.classification}}</span>
                    <span class="badge badge-success p-1 px-1" v-else-if="row.item.classification == 'sabung ayam'"> {{row.item.classification}}</span>
                    <span class="badge badge-light p-1 px-1" v-else> {{row.item.classification}}</span>
                </template>
                <template #cell(actions)="row">
                    <router-link :to="{ name: 'profile', params: { nik: row.item.nik }}"><b-button  class="mr-2 btn-sm" variant="info" >
                    <i class="fas fa-eye"></i> 
                    </b-button></router-link>
                    <b-button class="mr-2 btn-sm" variant="danger" @click="onDelete(row.item.nik)">
                    <i class="fas fa-trash"></i>
                    </b-button>
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-right">
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
// import i18n from "../i18n";

import { tableData } from "./dataAdvancedtable";

/**
 * Advanced table component
 */
export default {
  page: {
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout, PageHeader },
  data() {
    return {
      tableData: tableData,
      title: "Profile Database",
      items: [
        {
          text: "Home",
          href: "/"
        },
        {
          text: "Profile Database",
          active: true
        }
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "age",
      sortDesc: false,
      fields: [
        { key: "name", sortable: true, },
        { key: "nik", sortable: true },
        { key: "nkk", sortable: true },
        { key: "datebirth", sortable: true },
        { key: "birthplace", sortable: true },
        { key: "religion", sortable: true },
        { key: "gender", sortable: true },
        { key: "classification", sortable: true },
        { key: 'actions', class: 'text-center' }
      ]
    };
  },
  computed: {
    /**
     * Total no. of records
     */
    rows() {
      return this.tableData.length;
    }
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.items.length;
  },
  methods: {
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    onDelete(id){
        console.log('delete data:', id);
    },
     onView(id){
        console.log('details data:', id);
    }
  }
};
</script>

<style scoped>
.badge{
    border-radius: 2%;
}
.btn{
    border-radius: 7%;
}
</style>